function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 12.27V17.66C8 20 9.56 21.55 11.89 21.55H18.11C20.44 21.55 22 20 22 17.66V9.89C22 7.55 20.44 6 18.11 6H14.28C13.25 6 12.26 6.41 11.53 7.14L9.14 9.52C8.41 10.25 8 11.24 8 12.27Z",
  fill: "white",
  fillOpacity: 0.4
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.75 11C14.3358 11 14 11.3358 14 11.75V13.5H12.25C11.8358 13.5 11.5 13.8358 11.5 14.25C11.5 14.6642 11.8358 15 12.25 15H14V16.75C14 17.1642 14.3358 17.5 14.75 17.5C15.1642 17.5 15.5 17.1642 15.5 16.75V15H17.25C17.6642 15 18 14.6642 18 14.25C18 13.8358 17.6642 13.5 17.25 13.5H15.5V11.75C15.5 11.3358 15.1642 11 14.75 11Z",
  fill: "white",
  fillOpacity: 0.4
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.6,
  d: "M8.28027 1.96973C7.25031 1.96973 6.26027 2.38039 5.53027 3.11035L3.13965 5.5C2.40974 6.22994 2.00006 7.22011 2 8.25V13.6406C2.00018 15.9703 3.55998 17.5301 5.88965 17.5303H8V12.2695C8.00012 11.2397 8.40976 10.2494 9.13965 9.51953L11.5303 7.13965C12.2602 6.40984 13.2504 6 14.2803 6H16V5.86035C16 3.53047 14.4402 1.96988 12.1104 1.96973H8.28027Z",
  fill: "white"
});

var SvgCopytradeDark = function SvgCopytradeDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCopytradeDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copytrade_dark.a48fb46a.svg";
export { ForwardRef as ReactComponent };